// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2-3ZN","col":"styles_col__edSBu"};